import script from "./ExpansionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpansionPanel.vue?vue&type=script&setup=true&lang=js"

import "./ExpansionPanel.vue?vue&type=style&index=0&id=026e4f20&lang=scss"

const __exports__ = script;

export default __exports__